import { mdiBell } from '@mdi/js';
import { IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Icon } from 'common/components/Icon';
import { Tooltip } from 'common/components/Tooltip';
import { useCurrentUserQuery } from 'graphql/types';
import { Badge } from 'common/components/Badge';
import { getUrl } from 'route/utils/getUrl';

export const NotificationsNavigationItem = () => {
    const [translate] = useTranslation();
    const navigate = useNavigate();

    const { data } = useCurrentUserQuery();

    const unreadNotificationCount =
        data?.currentUser?.unreadNotificationCount || 0;

    return (
        <Tooltip title={translate('notificationsMenuItem')}>
            <IconButton
                size="large"
                sx={{ color: 'body.main' }}
                onClick={() => {
                    navigate(getUrl('NOTIFICATIONS_DRAWER'));
                }}
            >
                <Badge
                    badgeContent={
                        !!unreadNotificationCount
                            ? unreadNotificationCount
                            : undefined
                    }
                    color="error"
                >
                    <Icon path={mdiBell} size="2.1rem" />
                </Badge>
            </IconButton>
        </Tooltip>
    );
};
